"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$mergeObjects = void 0;
var mergeObjects_1 = require("../expression/object/mergeObjects");
/**
 * Combines multiple documents into a single document.
 *
 * @param {Array} collection The input array
 * @param {Object} expr The right-hand side expression value of the operator
 * @param {Options} options The options to use for this operation
 * @returns {Array|*}
 */
exports.$mergeObjects = mergeObjects_1.$mergeObjects;
